// components/MobileHeader.jsx
import React from "react";
import styled from "styled-components";
import { LuLogOut, LuCircleHelp } from "react-icons/lu";
import { getAuth, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom"; // ⬅️ novo
import { app } from "../firebase";

const HeaderWrapper = styled.header`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #3a79ed; /* azul padrão */
    padding: 12px 16px;
    color: #fff;
    position: sticky;
    top: 0;
    z-index: 50;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    box-shadow: 0 6px 16px rgba(0,0,0,.15);
  }
`;

const Left = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  min-width: 0;
  cursor: pointer;                /* ⬅️ vira clicável */
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  &:active {
    opacity: 0.9;
    transform: translateY(1px);
  }
`;

const Avatar = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  background: #e5e7eb;
  flex-shrink: 0;
`;

const Texts = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  min-width: 0;
`;

const Hi = styled.span`
  font-size: 12px;
  opacity: .95;
`;

const Name = styled.span`
  font-weight: 800;
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  svg { cursor: pointer; }
  svg:active { transform: translateY(1px); }
`;

export default function MobileHeader({
  userName = "Usuário",
  photoURL,
  onHelp,
  settingsPath = "/configuracoes",        // ⬅️ rota pode ser trocada
  onAvatarClick                            // ⬅️ opcional para sobrescrever comportamento
}) {
  const auth = getAuth(app);
  const navigate = useNavigate();

  const goToSettings = () => {
    if (typeof onAvatarClick === "function") {
      onAvatarClick();
      return;
    }
    try {
      navigate(settingsPath);
    } catch {
      // Fallback se o componente estiver fora do Router
      window.location.href = settingsPath;
    }
  };

  const onLeftKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      goToSettings();
    }
  };

  const logout = async () => {
    try {
      await signOut(auth);
      window.location.href = "/login";
    } catch {}
  };

  return (
    <HeaderWrapper>
      <Left
        onClick={goToSettings}
        role="button"
        tabIndex={0}
        onKeyDown={onLeftKeyDown}
        aria-label="Ir para configurações"
        title="Configurações"
      >
        <Avatar
          src={
            photoURL ||
            "https://firebasestorage.googleapis.com/v0/b/bigode-app-fade.firebasestorage.app/o/padrao-sistema%2Fbarbeiro.webp?alt=media&token=732c1f69-8182-414d-8237-ac0f509bf0fd"
          }
          alt="Avatar"
        />
        <Texts>
          <Hi>Bem-vindo,</Hi>
          <Name>{userName}</Name>
        </Texts>
      </Left>

      <Actions>
        <LuCircleHelp size={22} onClick={onHelp} title="Ajuda" />
        <LuLogOut size={22} onClick={logout} title="Sair" />
      </Actions>
    </HeaderWrapper>
  );
}
